import FormEquipo from '../componentes/FormEquipo.vue'
import ListaEquipo from '../componentes/ListaEquipo.vue'


const routes = [
    ...route('/guardar-equipo', FormEquipo, {
        Auth: true,
       
     }),
     ...route('/lista-equipo', ListaEquipo, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes